import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { warehouseAPI } from '../../api/warehouses';
import { AlertTriangle } from 'lucide-react';

export const StockAlertWidget: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [summary, setSummary] = useState({ lowStock: 0, overstock: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlertSummary = async () => {
      try {
        const result = await warehouseAPI.getAlertSummary();
        setSummary(result);
      } catch (error) {
        console.error('Failed to fetch stock alert summary:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlertSummary();
  }, []);

  if (loading) {
    return (
      <div className="rounded-lg border bg-white p-6 shadow-sm">
        <div className="animate-pulse">
          <div className="h-4 w-32 rounded bg-gray-200"></div>
          <div className="mt-2 h-8 w-20 rounded bg-gray-200"></div>
        </div>
      </div>
    );
  }

  if (summary.total === 0) {
    return null;
  }

  return (
    <div
      onClick={() => navigate('/warehouses/stock-alerts')}
      className="cursor-pointer rounded-lg border bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500">
            {t('warehouse.stockAlerts.dashboardWidget')}
          </p>
          <div className="mt-2 flex items-center gap-4">
            {summary.lowStock > 0 && (
              <div className="flex items-center gap-1">
                <span className="text-2xl font-bold text-red-600">
                  {summary.lowStock}
                </span>
                <span className="text-sm text-gray-600">
                  {t('warehouse.stockAlerts.lowStock')}
                </span>
              </div>
            )}
            {summary.overstock > 0 && (
              <div className="flex items-center gap-1">
                <span className="text-2xl font-bold text-yellow-600">
                  {summary.overstock}
                </span>
                <span className="text-sm text-gray-600">
                  {t('warehouse.stockAlerts.overstock')}
                </span>
              </div>
            )}
          </div>
          <p className="mt-2 text-sm text-gray-500">
            {summary.total} {t('warehouse.stockAlerts.activeAlerts')}
          </p>
        </div>
        <div className="rounded-full bg-red-100 p-3">
          <AlertTriangle className="h-8 w-8 text-red-600" />
        </div>
      </div>
    </div>
  );
};
